import CategoryView from "@/pages/category/components/CategoryView";
import { movieList } from "@/utils/mediaData";

export default function MovieCategoryPage() {
  return (
    <CategoryView
      type="movie"
      items={movieList}
      title="电影频道"
      description="海量电影资源精选，涵盖各类影片类型，尽在91n影视大全"
      breadcrumb="电影"
      bannerImage="https://readdy.ai/api/search-image?query=A%20dramatic%20dark%20cinema%20hall%20with%20a%20glowing%20screen%20and%20rows%20of%20empty%20seats%2C%20cinematic%20editorial%20photography%2C%20warm%20amber%20and%20deep%20red%20lighting%2C%20high%20detail%2C%20wide%20composition&width=1600&height=500&seq=category-banner-movie&orientation=landscape"
    />
  );
}